import type { MutationResult, ReasonInput } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { PageResult } from '../../shared/data/types';
import type {
  AssignmentChangeSet,
  AssignmentPreview,
  AssignmentPreviewInput,
  BindPartnerUserInput,
  ChangeMemberStatusInput,
  CreateAssignmentChangeSetInput,
  DirectDownline,
  DownlineQuery,
  MemberAssignment,
  MemberDetail,
  MemberListQuery,
  MemberSummary,
} from './types';

export interface MemberRepository {
  list(query: MemberListQuery, signal: AbortSignal): Promise<PageResult<MemberSummary>>;
  get(memberId: string, signal: AbortSignal): Promise<MemberDetail>;
  listDownlines(
    memberId: string,
    query: DownlineQuery,
    signal: AbortSignal,
  ): Promise<PageResult<DirectDownline>>;
  listAssignments(memberId: string, signal: AbortSignal): Promise<readonly MemberAssignment[]>;
  changeStatus(
    memberId: string,
    input: ChangeMemberStatusInput,
  ): Promise<MutationResult<MemberDetail>>;
  bindPartnerUser(
    memberId: string,
    input: BindPartnerUserInput,
  ): Promise<MutationResult<MemberDetail>>;
  rotateReferralCode(memberId: string, input: ReasonInput): Promise<MutationResult<MemberDetail>>;
  previewAssignment(input: AssignmentPreviewInput): Promise<AssignmentPreview>;
  createAssignmentChangeSet(
    input: CreateAssignmentChangeSetInput,
  ): Promise<MutationResult<AssignmentChangeSet>>;
  getAssignmentChangeSet(changeSetId: string, signal: AbortSignal): Promise<AssignmentChangeSet>;
  cancelAssignmentChangeSet(
    changeSetId: string,
    input: ReasonInput,
  ): Promise<MutationResult<AssignmentChangeSet>>;
}

export const memberRepositoryToken = createRepositoryToken<MemberRepository>('members');

export const defaultMemberListQuery: MemberListQuery = Object.freeze<MemberListQuery>({
  page: 1,
  pageSize: 25,
  sort: 'updatedAt',
  order: 'desc',
  filters: {
    partnerId: '',
    agentId: '',
    uplineMemberId: '',
    memberType: '',
    status: '',
    username: '',
    partnerUserId: '',
    referralCode: '',
  },
});

export const defaultDownlineQuery: DownlineQuery = Object.freeze<DownlineQuery>({
  page: 1,
  pageSize: 25,
  sort: 'updatedAt',
  order: 'desc',
  filters: { status: '', username: '', partnerUserId: '' },
});
